import React, { FC } from 'react';

import { NavigationSkeletonItem } from './NavigationSkeletonItem';

import './ReleaseNotesNavigationSkeleton.scss';

export const ReleaseNotesNavigationSkeleton: FC = () => {
	return (
		<div className="release-notes-navigation-skeleton">
			<nav aria-label="Evinced Products" className="vertical-disclosure-nav">
				<ul className="disclosure-nav-list">
					<NavigationSkeletonItem size="long" isActive />
					<NavigationSkeletonItem size="long" />
					<NavigationSkeletonItem size="long-full" />
					<NavigationSkeletonItem size="long-full" />
					<NavigationSkeletonItem size="long-full" />
					<NavigationSkeletonItem size="long-full" />
					<NavigationSkeletonItem size="long-full" />
					<NavigationSkeletonItem size="long-full" />
				</ul>
			</nav>
		</div>
	);
};
